import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [accountId, setAccountIdState] = useState(localStorage.getItem("bos_account"));
  const [recent, setRecent] = useState(() => JSON.parse(localStorage.getItem("bos_recent") || "[]"));

  const setAccountId = (id) => {
    if (id) localStorage.setItem("bos_account", id);
    else localStorage.removeItem("bos_account");
    setAccountIdState(id);
  };

  const enterAccount = (id) => {
    setAccountId(id);
    const next = [id, ...recent.filter((r) => r !== id)].slice(0, 5);
    localStorage.setItem("bos_recent", JSON.stringify(next));
    setRecent(next);
  };

  const loadAccounts = useCallback(async (u) => {
    const { data } = await api.get("/accounts");
    setAccounts(data);
    const current = localStorage.getItem("bos_account");
    if (u.role !== "agency_owner") setAccountId(u.account_id);
    else if (!current || !data.find((a) => a.id === current)) setAccountId(data[0]?.id || null);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("bos_token")) return setUser(false);
    api.get("/auth/me").then(async ({ data }) => {
      await loadAccounts(data);
      setUser(data);
    }).catch(() => {
      localStorage.removeItem("bos_token");
      setUser(false);
    });
  }, [loadAccounts]);

  const completeLogin = async (data) => {
    localStorage.setItem("bos_token", data.token);
    await loadAccounts(data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("bos_token");
    localStorage.removeItem("bos_account");
    localStorage.removeItem("bos_recent");
    setRecent([]);
    setUser(false);
  };

  const account = accounts.find((a) => a.id === accountId);
  return (
    <AuthCtx.Provider value={{ user, completeLogin, logout, accounts, account, accountId, setAccountId: enterAccount, recent, reloadAccounts: () => loadAccounts(user) }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
